query getSavedContentById($input: GetSavedContentInput!) {
  savedContent: getSavedContentById(input: $input) {
    id
    text
    imagePath
    imageSource
    textKind
    createdAt
    postedAt
    url
    carouselImages
    downloaded
    topicId
    postingBatchId
    invitationIds
    totalOffices
    totalRecipients
    recipientSegment
    targetLink
    topicName
    publication
    invitations {
      name
      recipientCount
      targetLink
      failedCount
      failedDeliveryError
    }
    platformTexts {
      INSTAGRAM
      LINKEDIN
    }
    socialMediaPosts {
      type
      permalink
      externalPostId
      hasFailed
      completedAt
      failureReason
      metrics {
        impressions
        likes
        comments
        shares
        fetchedAt
      }
    },
    posts {
      companyId
      companyName
      textKind
      url
      postingBatchId
      socialMediaPosts {
        type
        permalink
        postId
        scheduledAt
        id
        hasFailed
        completedAt
        failureReason
      }
    }
  }
}
